import { render, staticRenderFns } from "./ConTipoPolizaComponent.vue?vue&type=template&id=0abd21d9&"
import script from "./ConTipoPolizaComponent.vue?vue&type=script&lang=js&"
export * from "./ConTipoPolizaComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports